<template>
  <div class="content">
    <h1 class="content__title" v-text="texts.title"></h1>
    <span class="content__details" v-text="texts.subtitle"></span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Datos del Atributo</h2>

          <div class="waiting" v-if="loading">
            <img src="/static/img/waiting.gif" alt="Cargando Información" class="waiting__image">
          </div>

          <form class="form" @submit.prevent="saveAttribute" v-if="!loading">
            <div class="form__fielset">

              <div class="form__container form__container--short">
                <label for="name_es" class="form__label form__label--required">Nombre del Atributo</label>
                <input type="text" class="form__input" name="name_es" id="name_es" placeholder="Nombre del Atributo" v-model="attribute.name_es" v-validate="validation.name_es">
                <span v-show="errors.has('name_es')" class="form__alert">{{ errors.first('name_es') }}</span>
              </div>

              <div class="form__container form__container--small">
                <label for="code" class="form__label">Código del Atributo</label>
                <input type="text" class="form__input" name="code" id="code" placeholder="Código del Atributo" v-model="attribute.code" v-validate="validation.code">
                <span v-show="errors.has('code')" class="form__alert">{{ errors.first('code') }}</span>
              </div>

              <div class="form__container form__container--half">
                <label for="image" class="form__label">Imagen del atributo</label>
                <img v-if="thumb" :src="thumb" alt="" class="form__thumb">
                <button class="btn btn--regular btn__default" @click.prevent="addCover">Agregar Imagen</button>
                <button v-if="thumb" @click.prevent="removeImage" class="btn btn__transparent btn--regular">Quitar imagen</button>
                <span v-show="errors.has('image')" class="form__alert">{{ errors.first('image') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="type_id" class="form__label form__label--required">Tipo de Atributo</label>
                <div class="form__select-container">
                  <select name="type_id" id="type_id" class="form__select" v-validate="validation.type_id" v-model="attribute.type_id">
                    <option :value="null">Seleccionar Tipo de Atributo</option>
                    <option v-for="(type, index) in types" :key="index" :value="type.id" v-text="type.name_es"></option>
                  </select>
                </div>
                <span v-show="errors.has('type_id')" class="form__alert">{{ errors.first('type_id') }}</span>
              </div>

              <div class="form__container form__container--short">
                <label for="status_id" class="form__label form__label--required">Estatus</label>
                <div class="form__select-container">
                  <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="attribute.status_id">
                    <option :value="null">Seleccionar Estatus</option>
                    <option v-for="(status, index) in statusList" :key="index" :value="status.id" v-text="status.name"></option>
                  </select>
                </div>
                <span v-show="errors.has('status_id')" class="form__alert">{{ errors.first('status_id') }}</span>
              </div>

              <input type="submit" class="btn btn__default btn--regular" :value="texts.submit">

            </div>
          </form>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'productList', params: {page: 1}}">Lista de Productos</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeList', params: {page: 1}}">Lista de Atributos</router-link>
        <router-link v-if="$route.name === 'attributeEdit'" class="btn btn--small btn__default" :to="{name: 'attributeNew'}">Nuevo Atributo</router-link>
        <br>
        <h2 class="sidebar__title">CARACTERÍSTICAS</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeTypeList', params: {page: 1}}">Lista de Tipos</router-link>
      </aside>
    </div>
    <popup-viewer name="image" @close="mediaManager = false" v-if="mediaManager"></popup-viewer>
  </div>
</template>

<script>
import httpService from '@/api/request'
import {validation, attributeFields, statusList, texts} from './mocks'
import popupViewer from '@/components/media/popup'
export default {
  mixins: [httpService],
  components: {popupViewer},
  data: function () {
    return {
      validation: validation,
      attribute: null,
      types: [],
      statusList: statusList,
      mediaManager: false,
      thumb: null
    }
  },
  created: function () {
    this.start()
  },
  mounted: function () {
    this.$on('image', image => {
      this.attribute.image = JSON.stringify(image)
      this.thumb = image.images.thumb[0]
      this.mediaManager = false
    })
  },
  watch: {
    '$route.path': function () {
      this.thumb = null
      this.start()
    }
  },
  methods: {
    start: function () {
      this.getTypes()
      if (this.attributeId) {
        this.getAttr()
      }
      if (!this.attributeId) {
        this.attribute = new attributeFields()
      }
    },
    addCover: function () {
      this.mediaManager = true
    },
    removeImage: function () {
      this.thumb = null
      this.attribute.image = null
    },
    getTypes: function () {
      let httpRequest = {
        params: '',
        module: 'attribute_types'
      }
      this.get(httpRequest)
        .then(
          types => {
            this.types = types.data
          }
        )
    },
    getAttr: function () {
      let httpRequest = {
        params: '',
        module: 'attributes'
      }
      this.getById(this.attributeId, httpRequest)
        .then(
          attribute => {
            this.attribute = attribute.data
            if (attribute.data.image) {
              let thumb = JSON.parse(attribute.data.image)
              this.thumb = thumb.images.thumb[0]
            } else {
              this.thumb = null
            }
          }
        )
        .catch(
          () => {
            this.$router.push({name: 'attributeNew'})
          }
        )
    },
    saveAttribute: function () {
      this.$validator.validateAll()
        .then(
          response => {
            if (response) {
              let httpRequest = {
                params: '',
                module: 'attributes',
                element: this.attribute
              }
              let request
              if (this.$route.name === 'attributeEdit') {
                request = this.put(this.attributeId, httpRequest)
              } else if (this.$route.name === 'attributeNew') {
                request = this.post(httpRequest)
              }
              request.then(
                response => {
                  this.$store.commit('notificate', {
                    title: this.texts.messages.success.title,
                    text: this.texts.messages.success.text,
                    type: 'success'
                  })
                  if (this.$route.name === 'attributeNew') {
                    this.$router.push({name: 'attributeEdit', params: {id: response.data.current_id}})
                  }
                }
              )
            } else {
              this.$store.commit('notificate', {
                title: 'CAMPOS REQUERIDOS',
                text: 'Por favor, revise el formulario, existen campos requeridos que no han sido completados.',
                type: 'warn'
              })
            }
          }
        ).catch(
          error => {
            console.log(error)
          }
        )
    }
  },
  computed: {
    attributeId: function () {
      return this.$route.params.id
    },
    loading: function () {
      return this.$route.params.id && !this.attribute
    },
    texts: function () {
      return texts[this.$route.name]
    }
  }
}
</script>

<style lang="sass">
@import "../../../assets/sass/objects/_btns"
@import "../../../assets/sass/components/layout/_forms"
</style>



// WEBPACK FOOTER //
// src/components/products/attributes/edit.vue